import { createComponent } from '@mtfe/sweet';
import { lazyLoadImg } from '@mtfe/sweet-utils';

import componentUtils from '../utils/index';
import tpl from './dom.html';
import style from './style.less';

const { Describe } = componentUtils;

const { DEFAULT_DATA_SRC } = lazyLoadImg;
const COMPONENT_ID = 'waimai_tsszzaeh';

const describePoiInfoD = new Describe('PoiInfoD', COMPONENT_ID);

const PoiInfoD = (props) => {

    const { poiInfo, isLazyLoadImg, onPoiInfoClick, itemIndex = -1 } = props || {};

    let ugc = '';
    const poi_label_map_10 = poiInfo.poiBaseInfo.poi_label_map['10'];
    if (poi_label_map_10 && poi_label_map_10[0]) {
        ugc = (poi_label_map_10[0].content || '').replace(/^“+|”+$/gm, '');
        if (ugc.length > 15) {
            ugc = ugc.substring(0, 15) + '...';
        }
    }

    const data = {
        itemIndex,
        DEFAULT_DATA_SRC,
        poiInfo,
        isLazyLoadImg,
        ugc,
    };
    const events = {
        onPoiInfoClick: () => {
            if (onPoiInfoClick) {
                onPoiInfoClick();
                return false;
            }
        },
    };
    const component = createComponent(tpl, { data, style }, events);

    return component;
}

PoiInfoD.describe = describePoiInfoD;
export default PoiInfoD;